(function( $ ) {

    "use strict";

    /**
     * Bootstrap Bugfix Navi Mobile
     * Open 2nd dropdown
     * try https://www.$script.net/menu/$-Plugin-For-Multilevel-Bootstrap-Dropdown-Navigation.html
     *
     * https://www.$script.net/menu/mobile-multi-level-dropdown-bootstrap.html  not working a second time
     */
    function naviHwkMobile() {

        // 1) The $ script to prevent closing from click inside the dropdown
        $(document).on('click', '.dropdown-menu', function( e ) {
            e.stopPropagation();
        });
        // 2) Convert the multi-level dropdown into an accordion when running on a small screen device
        if( $(window).width() < 767 ) {
            $('.dropdown a').click(function( e ) {
                if( $(this).attr('href') === '#' ) {
                    e.preventDefault();
                }
                $(this).parent('.dropdown').toggleClass('hwk-open');
            });


            $('.dropdown').on('click.bs.dropdown', function( e ) {

                if( $(e.currentTarget).parents('.dropdown').length > 0 ) {
                    e.stopPropagation();
                    //console.log( e.currentTarget, $(e.currentTarget).parents('.dropdown').length);
                }
            });
        }
    }

    /**
     * if not mega menu
     * check for third dropdown
     * and get first href of third dropdown
     */
    function checkNaviHwkNotMobile() {
        if( $('body.submenu-full-width').length == 0) {
            const mainMenuFirstDropdown = $('#main-menu-ul > li.dropdown > .dropdown-menu');
            $(mainMenuFirstDropdown).each(function( i, menuFirstDropdown ) {
                const menuSecondDropdown = $(menuFirstDropdown).find('> li.dropdown');
                $(menuSecondDropdown).each(function( x, li ) {
                    if( $(li).children('a').attr('href').trim() === '#') {
                        let firstHref = $(li).find('> .dropdown-menu > li > a').first().attr('href');
                        $(li).find('> a').attr('href', firstHref);
                    }
                });
            });
        }
    }

    function initHwkNavi() {
        if( getBrowserSize() == 'xs' ) {
            naviHwkMobile();
        } else {
            checkNaviHwkNotMobile();
        }
    }

    initHwkNavi();

}(jQuery));